module.exports = __webpack_public_path__ + "assets/img/travel-day20.eed07b16.png";